import { ReactElement } from "react";
import { Model_ProjectProductsFilterPut } from "src/backend/openapi/v1";
import { TViewMode } from "src/components/view-mode/view-mode-types";
import { configuratorPageK } from "src/translation-hooks/configurator-page";
import { genericTranslationsK } from "src/translation-hooks/generic-translations";

export type TRenderStep =
  | {
      dialogTitle: string;
      component: ReactElement;
      saveAndCancelButton: {
        saveDisabled: boolean;
        saveLabel: keyof typeof configuratorPageK;
        saveFn: () => void;
        cancelLabel: keyof typeof genericTranslationsK;
        cancelFn: () => void;
      };
      onClose?: () => void;
    }
  | undefined;

export type TAddEditConfigurationDialog = { step: "SELECT SYSTEM" | "SELECT PRODUCT" } | { step: "PRODUCT-DETAILS"; productId: string };

export type TFormData = Partial<{
  selectedProductId: string;
  viewMode: TViewMode;
  productsFilter: Model_ProjectProductsFilterPut;
}>;

export const ITEM_CARD_IMAGE_HEIGHT = 200;
